import { axiosInstance } from "@/helper/axios-instance";
import { Dictionary, DataAwareResponse } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useDictUpdate() {
  return useMutationWithValidation({
    mutationFn: async (data: Partial<Dictionary>) => {
      const response = await axiosInstance({
        method: "POST",
        url:  `Dictionary/Update`,
        data: data,
      });

      return response.data as DataAwareResponse<Dictionary>;
    },
    retry: 2,
    customMessage: {
      success: "Dictionary updated successfully",
    },
  });
}
